/**
 * Хук видимости модуля. Возвращает `true` если:
 *  - модуль есть в `ModulesContext` и `enabled === true`;
 *  - модуль ОТСУТСТВУЕТ в контексте (данные ещё не загружены, фетч упал
 *    или провайдер вообще не подключён — например, в unit-тестах
 *    компонентов) — default-visible.
 *
 * `false` — если модуль явно выключен супер-админом: флаги приходят всем —
 * и обычным пользователям, и анониму — через `/api/public/modules`
 * (US-09 FR-1.4).
 */
import { useContext } from 'react';

import { ModulesContext } from '../contexts/ModulesContext';

export const useModulePresent = (moduleId: string): boolean => {
  const ctx = useContext(ModulesContext);
  if (!ctx) return true; // нет провайдера → default-visible
  const entry = ctx.modules.get(moduleId);
  if (entry === undefined) return true;
  return entry.enabled;
};

/**
 * «Хоть один из виджетов включён» — для обёрток, которые без своих
 * виджетов не нужны (заголовок группы, ряд плиток). Читает контекст один
 * раз, поэтому список id может быть любой длины.
 */
export const useAnyModulePresent = (ids: readonly string[]): boolean => {
  const ctx = useContext(ModulesContext);
  if (!ctx) return true; // нет провайдера → default-visible
  return ids.some((id) => ctx.modules.get(id)?.enabled !== false);
};
